import { LayerData } from './layer.data';

export class TintableLayerData extends LayerData {

  protected _color:string;
	static _DEFAULT_COLOR: string = "#000000";
  /**
   * Contructor
   */
	constructor(color: string, x:number = 0, y:number = 0, width:number = NaN, height:number = NaN, rotation:number = 0, alpha:number = 1, locks:any = null, source:string = "CreationLayer", special:string = null) {
    super(x, y, width, height, rotation, alpha, locks, source, special);
		
		this._tintable = true;
    this._color = color;
  }
  
  /**
	 * Set default color
	 */	
	static get DEFAULT_COLOR(): string {
		return this._DEFAULT_COLOR;
	}
		
	static set DEFAULT_COLOR(value: string) {
		this._DEFAULT_COLOR = value;

	}
	
	/**
	 * Color
	 */		
	public get color(): string {
		return this._color;
	}
	public set color(value: string) {
		this._color = value;
	}
    
}
